import React from 'react';

/**
 * DeTimeline — 4-step horizontal progress bar for Edit Data Entry mode.
 *
 * Mirrors the old software's react-step-progress-bar but uses pure Bootstrap 5
 * layout + CSS only — no extra npm packages needed.
 *
 * Steps are linked to the right-sidebar action buttons:
 *   1 → Copy Document
 *   2 → Clearing Charges
 *   3 → Eway
 *   4 → P & L
 *   5 → File Document
 *   6 → Bank Details
 *
 * Props:
 *   activeStep  {number}  1–6 — which step is currently highlighted
 */
const STEPS = [
  { num: 1, label: 'Copy Document' },
  { num: 2, label: 'Clearing Charges' },
  { num: 3, label: 'Eway' },
  { num: 4, label: 'P & L' },
  { num: 5, label: 'File Document' },
  { num: 6, label: 'Bank Details' },
];

const DeTimeline = ({ activeStep = 1 }) => {
  // Progress percentage: fills the connecting line between step circles
  const progressPct = ((activeStep - 1) / (STEPS.length - 1)) * 100;

  return (
    <div className="de-timeline mb-2">
      {/* Track — the horizontal line behind all steps */}
      <div className="de-timeline-track">
        <div
          className="de-timeline-fill"
          style={{ width: `${progressPct}%` }}
        />
      </div>

      {/* Step circles + labels */}
      {STEPS.map((step) => {
        const isDone    = step.num < activeStep;
        const isCurrent = step.num === activeStep;

        return (
          <div key={step.num} className="de-timeline-step">
            <div
              className={[
                'de-timeline-circle',
                isDone    ? 'done'    : '',
                isCurrent ? 'current' : '',
              ].join(' ')}
            >
              {isDone ? (
                /* Checkmark for completed steps */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                </svg>
              ) : (
                step.num
              )}
            </div>
            <span className={`de-timeline-label d-none d-sm-block${isCurrent ? ' current' : ''}`}>
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default DeTimeline;
